import { render, staticRenderFns } from "./Exercisetesting.vue?vue&type=template&id=d1a8aaae&scoped=true"
import script from "./Exercisetesting.vue?vue&type=script&lang=js"
export * from "./Exercisetesting.vue?vue&type=script&lang=js"
import style0 from "./Exercisetesting.vue?vue&type=style&index=0&id=d1a8aaae&prod&scoped=true&lang=css"
import style1 from "./Exercisetesting.vue?vue&type=style&index=1&id=d1a8aaae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a8aaae",
  null
  
)

export default component.exports